module.exports = __webpack_public_path__ + "dcf60fea147cd8b5fc5e7e00bfc38687.pdf";